import { render, staticRenderFns } from "./talentIndex.vue?vue&type=template&id=5fa75d7a&scoped=true&"
import script from "./talentIndex.vue?vue&type=script&lang=ts&"
export * from "./talentIndex.vue?vue&type=script&lang=ts&"
import style0 from "./talentIndex.vue?vue&type=style&index=0&id=5fa75d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa75d7a",
  null
  
)

export default component.exports